import {AbstractControl, ValidatorFn} from '@angular/forms';
import {Role} from '../enums/role.enum';

export function roleValidator(currentUserRole: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (
            control.value === Role.admin && currentUserRole === Role.manager ||
            control.value === Role.manager && currentUserRole === Role.manager
        ) {
            return { roleError: true };
        }
        return null;
    };
}
